// schema
import * as ISchema from "#webapp/src/__schema__";

// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";

// pricing-dialog imports
import { pricingDialogFragments } from "./PricingDialog.gql";
import { styles } from "./PricingDialog.styles";
import { IContainer, IDialogViewState, IProps, IState } from "./PricingDialogTypes";

// other imports
import { CheckoutFormRenderer } from "#webapp/src/components/checkout-form";
// import { ChromeDialog } from 'src/components/chrome-dialog';

// state
import { setPricingDialogOpen } from "#webapp/src/state/actions/payments.actions";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";

// util
import { page, PageEvents } from "#webapp/src/util/analytics.util";

// material-ui
import { ChromeDialog } from "#webapp/src/components/chrome-dialog";
import { ArrowBack, Close } from "@clockwise/design-system/icons";
import { IconButton } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { OrgPricingGrid } from "../pricing-grid/org-pricing-grid";
///////////////
// Component //
///////////////
class PricingDialogCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      view: props.initialView ? props.initialView : "Pricing",
      selectedTeamId: props.teamId,
      selectedBillingRecurrence: ISchema.SubscriptionInterval.Yearly,
    };
  }

  // ~-~-~-~-~-~-~-
  // Lifecycle
  // ~-~-~-~-~-~-~-
  public componentDidMount() {
    page(PageEvents.PRICING_DIALOG);
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private onChangeView = (view: IDialogViewState) => {
    this.setState({ view });
  };

  private onChangeTeam = (selectedTeamId: string) => {
    this.setState({ selectedTeamId });
  };

  private onChangeBillingRecurrence = (selectedBillingRecurrence: ISchema.SubscriptionInterval) => {
    this.setState({ selectedBillingRecurrence });
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderPricing = () => {
    const { selectedBillingRecurrence } = this.state;

    return (
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", flexDirection: "row-reverse", padding: "10px 10px 0" }}>
          <IconButton onClick={() => this.props.setPricingDialogOpen(false)}>
            <Close />
          </IconButton>
        </div>
        <div className="cw-p-10">
          <OrgPricingGrid
            billingRecurrence={selectedBillingRecurrence}
            onChangeDialogView={this.onChangeView}
            isDialog={true}
          />
        </div>
      </div>
    );
  };

  private renderCheckout = () => {
    const { org, relay } = this.props;
    const { selectedTeamId, selectedBillingRecurrence } = this.state;
    return (
      <div style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 10px 0",
          }}
        >
          <IconButton onClick={() => this.onChangeView("Pricing")}>
            <ArrowBack />
          </IconButton>
          <IconButton onClick={() => this.props.setPricingDialogOpen(false)}>
            <Close />
          </IconButton>
        </div>
        <CheckoutFormRenderer
          environment={relay.environment}
          orgRelayId={org.id}
          teamId={selectedTeamId}
          onChangeTeam={this.onChangeTeam}
          billingRecurrence={selectedBillingRecurrence}
          onChangeBillingRecurrence={this.onChangeBillingRecurrence}
          isDialog={true}
          startCheckoutWithTeamSelected={this.props.initialView === "Checkout"}
        />
      </div>
    );
  };
  public render() {
    const { classes } = this.props;
    const { view } = this.state;

    return (
      <ChromeDialog
        key="pricing-modal"
        open={true}
        onClose={() => this.props.setPricingDialogOpen(false)}
        scroll="body"
        maxWidth="lg"
        classes={{
          paper: classes.paper,
        }}
        BackdropProps={{
          classes: { root: classes.backdrop },
        }}
        PaperProps={{
          classes: { rounded: classes.rounded },
        }}
      >
        {view === "Pricing" ? this.renderPricing() : this.renderCheckout()}
      </ChromeDialog>
    );
  }
}

/////////////////
// With Styles //
/////////////////
export const PricingDialogStyled = withStyles(styles)(PricingDialogCmpt);

///////////
// Redux //
///////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {
    shouldRefetchDueToPlanUpgrade: _state.payments.shouldRefetchDueToPlanUpgrade,
  };
}

const PricingDialogRedux = connect(mapStateToProps, {
  setPricingDialogOpen,
})(PricingDialogStyled);

///////////
// Relay //
///////////
export const PricingDialog = createFragmentContainer<IContainer>(
  PricingDialogRedux,
  pricingDialogFragments,
);
